import { connect } from 'react-redux'
import get from 'lodash/get';

import {
  setCenterMap as onSetCenterMap,
  clearCenterMap as onClearCenterMap,
} from '../../actions/mainMapActions'

const mapStateToProps = (state) => ({
  mainMapCenter: get(state, ['mainMap', 'mapCenter'], null),
});

const mapDispatchToProps = {
  onSetCenterMap,
  onClearCenterMap,
}

const withMainMap = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withMainMap }